import { useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "@/theme";
import { Button } from "@/components/Button";
import { PageModule } from "@/components/PageModule";
import Sticky from "@/components/Sticky";

export interface LandingPageBannerProps {
  buttonLabel: string;
  buttonLink: string;
  offerTitle?: string;
  offerText?: string;
  showLogo: boolean;
  anchor: "top" | "bottom";
}

export const LandingPageBanner = ({
  buttonLabel,
  buttonLink,
  offerTitle,
  offerText,
  showLogo,
  anchor,
}: LandingPageBannerProps) => {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );

  const hasOffer = offerTitle || offerText;

  return (
    <Sticky anchor={anchor} displayThreshold={isMobile ? 100 : 125}>
      <div className="bg-white text-white">
        <PageModule className="max-w-full py-4 md:py-2">
          <div
            className={`flex w-full ${
              (hasOffer || !showLogo) && isMobile
                ? "flex-col content-start"
                : "flex-row"
            } justify-between md:flex-row`}
          >
            <div
              className={`${
                hasOffer && isMobile ? "mb-2 " : "mb-0"
              } flex md:mb-0`}
            >
              {showLogo && (
                <img
                  className="w-20 md:w-24"
                  src={
                    "https://cdn.shopify.com/s/files/1/0268/4219/files/dropps-rebrand-logo.svg?v=1605548743"
                  }
                  alt=""
                />
              )}

              <div
                className={`${showLogo && "ml-6"} flex flex-col 
                 justify-center
                `}
              >
                <p className="title text-md md:text-lg">{offerTitle}</p>
                <p className="body text-sm md:text-md">{offerText}</p>
              </div>
            </div>
            <Button
              component="a"
              href={buttonLink}
              size={isMobile ? "md" : "lg"}
            >
              {buttonLabel}
            </Button>
          </div>
        </PageModule>
      </div>
    </Sticky>
  );
};
